import { Button, Card, Col, Space, Tooltip } from 'antd';
import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';

/**
 * One pie-chart panel on an insights page, with a "widen to full page" toggle.
 *
 * Most of the time a single breakdown is the one being studied, and a third of
 * the page is a cramped place to read a pie plus its table. When a panel is
 * widened the others are unmounted rather than pushed below the fold: they would
 * otherwise keep refetching and stretch the page for no benefit.
 *
 * `expandedKey` is owned by the page so only one panel can hold the floor.
 */
const InsightsChartCard = ({
  chartKey,
  title,
  extra,
  expandedKey,
  onToggleExpanded,
  // Grid sizing when NOT expanded. Defaults to the three-up insights layout;
  // a page with fewer panels passes its own so they still fill the row.
  defaultSpan = { xs: 24, md: 12, xl: 8 },
  children,
}) => {
  const isExpanded = expandedKey === chartKey;

  // Another panel has the floor.
  if (expandedKey && !isExpanded) return null;

  const span = isExpanded ? { xs: 24 } : defaultSpan;

  return (
    <Col {...span} className="gutter-row">
      <Card
        title={title}
        extra={
          <Space size={4}>
            <Tooltip title={isExpanded ? 'Pomanjšaj nazaj' : 'Razširi čez celo širino'}>
              <Button
                size="small"
                icon={isExpanded ? <CompressOutlined /> : <ExpandOutlined />}
                onClick={() => onToggleExpanded(isExpanded ? null : chartKey)}
              />
            </Tooltip>
            {extra}
          </Space>
        }
      >
        {children}
      </Card>
    </Col>
  );
};

export default InsightsChartCard;
